module.exports = __webpack_public_path__ + "img/sp-logo-eq-red.ffc664f3.png";